import { IncidentPriority, IncidentType, UserInfo } from '@evorait/pace-core';

/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export enum DocumentSharpServiceNames {
    AT = 'Service Information Content Feedback - AT',
    AX = 'Service Information Content Feedback - AT',
    CT = 'Service Information Content Feedback - CT',
    XP = 'Service Information Content Feedback - XP',
    SP = 'Service Information Content Feedback - XP',
    MR = 'Service Information Content Feedback - MR',
    SY = 'Service Information Content Feedback - DA',
    MI = 'Service Information Content Feedback - MI',
    US = 'Service Information Content Feedback - US',
    DC = 'Service Information Content Feedback - LS',
    DH = 'Service Information Content Feedback - LS',
    LD = 'Service Information Content Feedback - LS',
    DP = 'Service Information Content Feedback - POC',
    DM = 'Service Information Content Feedback - POC',
    PT = 'Service Information Content Feedback - PT',
    TH = 'Service Information Content Feedback - PT',
    OTHER = 'Service Information Content Feedback - CS',
}

export class DocumentFeedbackSharpPayload {
    public constructor(
        private externalID: string, // unique for each transaction
        private serviceOffering: DocumentSharpServiceNames,
        private priority: IncidentPriority,
        private shortDescription: string,
        private detailedDescription: string,
        private incidentType: IncidentType,
        private receiver: UserInfo,
        private requester: UserInfo,
        private attachment: [],
        private ci = 'PACE FORMS',
        private ticketStatus = 'New',
        private subCI = '',
        private subsubCI = '',
        private correlationSource = 'PACE_FORMS',
        private contactType = 'Phone',
        private internalWorkNotes = '',
        private subcategory = '',
        private customerCommunication = '',
        private CorrelationTarget = 'SHARP_INC01',
    ) {}
}
